module.exports = __webpack_public_path__ + "static/img/ban02.cd451e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v2/ban02.jpg
// module id = Yyhh
// module chunks = 76